import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { categories } from '../data/mockData';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showProductMenu, setShowProductMenu] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
    } else {
      alert('Please enter a keyword first.');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="logo">
          <img src="/images/slider/logo.png" alt="Flyingking Logo" />
        </div>
        <div className="logo-text">
          <img src="/images/slider/logot.png" alt="Flyingking Saddlery" />
        </div>
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Product Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button className="search-btn" onClick={handleSearch}>
            go
          </button>
        </div>
      </div>

      <nav className="navigation">
        <ul className="nav-menu">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li
            onMouseEnter={() => setShowProductMenu(true)}
            onMouseLeave={() => {
              setShowProductMenu(false);
              setSelectedCategory(null);
            }}
          >
            <Link to="/products">Products</Link>
            {showProductMenu && (
              <div className="dropdown-menu">
                <ul className="category-list">
                  {categories.map((category) => (
                    <li
                      key={category.id}
                      onMouseEnter={() => setSelectedCategory(category.name)}
                      onClick={() => {
                        navigate(`/products?category=${encodeURIComponent(category.name)}`);
                        setShowProductMenu(false);
                      }}
                    >
                      {category.name}
                    </li>
                  ))}
                </ul>
                {selectedCategory && (
                  <div className="subcategory-menu">
                    <ul>
                      {categories
                        .find((c) => c.name === selectedCategory)
                        ?.subcategories.map((sub, idx) => (
                          <li
                            key={idx}
                            onClick={() => {
                              navigate(
                                `/products?category=${encodeURIComponent(
                                  selectedCategory
                                )}&subcategory=${encodeURIComponent(sub)}`
                              );
                              setShowProductMenu(false);
                            }}
                          >
                            {sub}
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </li>
          <li>
            <Link to="/news">New</Link>
          </li>
          <li>
            <Link to="/contact">Contact Us</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
